import type { Card as CardType, CardColor, CardValue } from "@shared/cards";

interface CardProps {
  card: CardType;
  size?: "normal" | "small" | "tiny";
  onClick?: () => void;
  playable?: boolean;
  unplayable?: boolean;
}

const SYMBOL: Record<CardValue, string> = {
  "0": "0",
  "1": "1",
  "2": "2",
  "3": "3",
  "4": "4",
  "5": "5",
  "6": "6",
  "7": "7",
  "8": "8",
  "9": "9",
  skip: "⊘",
  reverse: "↺",
  draw2: "+2",
  wild: "★",
  wild4: "+4",
};

const COLOR_LABEL: Record<CardColor, string> = {
  red: "Red",
  yellow: "Yellow",
  green: "Green",
  blue: "Blue",
  wild: "Wild",
};

export function Card({ card, size = "normal", onClick, playable, unplayable }: CardProps): JSX.Element {
  const cls = [
    "card-face",
    size === "small" ? "small" : size === "tiny" ? "tiny" : "",
    `color-${card.color}`,
    playable ? "playable" : "",
    unplayable ? "unplayable" : "",
  ]
    .filter(Boolean)
    .join(" ");
  return (
    <div className={cls} onClick={onClick} role={onClick ? "button" : undefined}>
      <div className="symbol">{SYMBOL[card.value]}</div>
      <div className="label">{COLOR_LABEL[card.color]}</div>
    </div>
  );
}

export function CardBack({ size = "normal" }: { size?: "normal" | "small" | "tiny" }): JSX.Element {
  const cls = ["card-back", size === "small" ? "small" : size === "tiny" ? "tiny" : ""].filter(Boolean).join(" ");
  return <div className={cls}>UNO</div>;
}
